import React, { useContext, useEffect, useRef, useState, useMemo, ReactNode } from "react";
import { Row, Col, Carousel, Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { MeetingContext } from "@/pages/Meeting";
import { ParticipantType } from "@/types";
import VideoCard from "../VideoCard";
import style from "./style.module.scss";
//import { useUpdateEffect } from "ahooks"

const GalleryLayout = () => {
  const { participants, service } = useContext(MeetingContext);
  const carousel = useRef<any>();
  const [page, setPage] = useState(0);
  const pageSize = 9;

  useEffect(() => {
    console.log("[GalleryLayout] muteVideo");
    //muteVideo(page, 9, participants);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    //遍历participants,拉取当前页面的视频,如果某个已经有了视频了，就不要重复拉了
    //如果有本地视频，第一个应该是自己的视频
    (async function initFunction() {
      // if(participants.length === 1){
      //   return;
      // }
      console.log(`[DEBUG] [GalleryLayout] participants length=${participants.length} page=${page}`);
      for (let i = 1; i < participants.length; i++) {
        const participant = participants[i];
        
        if ((i >= page * pageSize && i < (page + 1) * pageSize)){
          if (participant.videoTrack) {
            continue;
          }
          
          console.log(`[GalleryLayout] subscribeVideo i=${i}`)
          await service.setParticipantInActivePage(participant.peerId, true);
          
        }else{
          console.log(`[GalleryLayout] unsubscribeVideo i=${i}`)
          await service.setParticipantInActivePage(participant.peerId, false);
        }
        //service.startLocalAudio( )
      }
    })();
  }, [page, participants.length] );

  //还有一种情况是participants里面某个人的video变成了available，这时候要判断这个人是否在当前页，如果在则拉取视频

  const next = () => {
    carousel.current.next();
  };

  const prev = () => {
    carousel.current.prev();
  };

  const pagination = useMemo((): ParticipantType[][] => {
    const res = [];
    //先过滤掉共享视频流,宫格模式不显示共享视频流
    const filteredParticipants = participants.filter((d) => {
      return d.share !== true;
    });
    for (let i = 1; i <= Math.ceil(filteredParticipants.length / pageSize); i++) {
      res.push(filteredParticipants.slice((i - 1) * pageSize, i * pageSize));
    }
    return res;
  }, [participants]);

  // const getPeerView = (cols:number, peers:ParticipantType[]): ReactNode=>{
  //   const res = [];
  //   for(let i=0; i<peers.length; i++){
  //     res.push(<Col key={i} flex={`0 0 ${(1 / cols) * 100}%`}>
  //     <VideoCard participant={peers[i]} />
  //     </Col>);
  //   }
  //   return res;
  // }
  
  //  const getPaginationView = (): ReactNode=>{
  //   const res = [];
  //   for(let i=0; i<pagination.length; i++){
  //     const cols = Math.ceil(Math.sqrt(pagination[i].length));
  //     res.push(
  //       <div key={i} className={style.container}>
  //         <Row gutter={8} justify="center">
  //           {getPeerView(cols, pagination[i])}
  //         </Row>
  //       </div>
  //     );
  //   }
  //   return res;
  //  }
  return (
    <div className={style.pagination}>
      <Carousel ref={carousel} dots={false} afterChange={setPage}>
        {pagination.map((peers, i: number) => {
          const cols = Math.ceil(Math.sqrt(peers.length));
          return (
            <div key={i} className={style.container2}>
              <Row gutter={8} justify="center">
                {peers.map((d: any, i: number) => (
                  <Col key={i} flex={1}>
                    <VideoCard participant={d} />
                  </Col>
                ))}
              </Row>
            </div>
          );
        })}
      </Carousel>
      {participants.length > pageSize && (
        <>
          <Button
            className={style.prev}
            icon={<LeftOutlined />}
            shape="circle"
            disabled={page <= 0}
            onClick={prev}
          />
          <Button
            className={style.next}
            icon={<RightOutlined />}
            shape="circle"
            disabled={page >= participants.length / pageSize - 1}
            onClick={next}
          />
        </>
      )}
    </div>
  );
};

export default GalleryLayout;
